export const VITAPEN_TEST_START = 'vitapen-test-start';
export const VITAPEN_TEST_RESULTS = 'vitapen-test-results';
export const VITAPEN_TEST_END = 'vitapen-test-end';
export const VITAPEN_MEASUREMENT_START = 'vitapen-measurement-start';
export const VITAPEN_MEASUREMENT_END = 'vitapen-measurement-end';
